import React from 'react';

const InterpretationCards = ({ vm }) => {
  const { exposicao, maturidade } = vm.interpretacoes;
  
  const styles = {
    container: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
      gap: '24px',
      marginBottom: '32px'
    },
    card: {
      padding: '24px',
      background: 'white',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    },
    sectionTitle: {
      fontSize: '1.25rem',
      fontWeight: '600',
      color: '#1e293b',
      marginBottom: '24px'
    },
    label: {
      display: 'inline-block',
      padding: '4px 12px',
      borderRadius: '6px',
      fontSize: '0.875rem',
      fontWeight: '600',
      marginBottom: '12px'
    },
    exposureLabel: {
      backgroundColor: vm.cores.faixa + '20',
      color: vm.cores.faixa
    },
    maturityLabel: {
      backgroundColor: '#6366f120',
      color: '#6366f1'
    },
    headline: {
      fontSize: '1.125rem',
      fontWeight: '600',
      color: '#1e293b',
      marginBottom: '12px'
    },
    text: {
      fontSize: '0.9375rem',
      color: '#64748b',
      lineHeight: '1.6',
      margin: 0
    }
  };

  return (
    <>
      <h3 style={styles.sectionTitle}>Interpretação dos Resultados</h3>
      <div style={styles.container}>
        <article style={styles.card}>
          <div style={{...styles.label, ...styles.exposureLabel}}>
            {exposicao.label}
          </div>
          <h4 style={styles.headline}>{exposicao.headline}</h4>
          <p style={styles.text}>{exposicao.texto}</p>
        </article>
        
        <article style={styles.card}>
          <div style={{...styles.label, ...styles.maturityLabel}}>
            Nível de Maturidade: {maturidade.label}
          </div>
          <p style={styles.text}>{maturidade.texto}</p>
        </article>
      </div>
    </>
  );
};

export default InterpretationCards;